<template>
  <div class="park-tradesmanlist">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input
              v-model="formItem.key"
              clearable
              style="width:200px"
              placeholder="输入手机号/店铺名称/姓名..."
            ></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
          <!-- <FormItem>
            <Button type="success" @click="createAgentTradesMan()">新增</Button>
          </FormItem>-->
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>

    <Modal v-model="showModalStatus" title="添加商户" @on-ok="ok" :width="800">
      <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table
        border
        :columns="columns2"
        ref="selection"
        :data="columns2List"
        :loading="dataloading"
        @on-selection-change="handleSelectRow()"
      ></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page
            ref="listPage1"
            :total="pages1.total"
            :current="pages1.page"
            :page-size="pages1.size"
            show-elevator
            show-total
            @on-change="changePage1()"
          ></Page>
        </div>
      </div>
    </Modal>

    <!-- 商家 弹出 -->
    <Modal
      v-model="showModalStatus3"
      title="分销比例"
      @on-ok="editTrade('dataInfoValidate')"
      :loading="loading"
    >
      <span style="color:red;">*园区服务费，按已成交金额核算</span>
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
        :label-width="80"
      >
        <FormItem label="云支付分销比例" prop="underline_fx">
          <Input v-model="dataInfo.underline_fx" placeholder="输入云支付分销比例"></Input>
        </FormItem>
        <FormItem label="	商城分销比例" prop="on_fx">
          <Input v-model="dataInfo.on_fx" placeholder="输入商城分销比例"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 匠人信息修改 -->
    <Drawer
      :title="title"
      v-model="showModalStatus4"
      width="1000"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="tradesman" :label-width="60" ref="tradesmanValidate" :rules="tradesmanValidate">
        <FormItem label="选择匠人分类" label-position="top">
          <Select v-model="tradesman.cate_id" clearable filterable placeholder="选择匠人分类">
            <Option v-for="item in cateList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="选择技艺" label-position="top">
          <Select v-model="tradesman.skill" clearable filterable placeholder="选择技艺">
            <Option v-for="item in skillList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="选择项目" label-position="top">
          <Select v-model="tradesman.intangible_id" clearable filterable placeholder="选择项目">
            <Option v-for="item in intangibleList" :value="item.id" :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="助力技艺" label-position="top" prop="helpless_skill">
          <Input v-model="tradesman.helpless_skill"></Input>
        </FormItem>
        <FormItem label="选择匠人类型" label-position="top">
          <Select v-model="tradesman.type" clearable filterable placeholder="选择匠人类型">
            <Option :value="1" :key="1">企业认证</Option>
            <Option :value="2" :key="2">个人认证</Option>
          </Select>
        </FormItem>
        <FormItem label="匠人等级" label-position="top">
          <Input v-model="tradesman.auth_company"></Input>
        </FormItem>
        <FormItem label="店铺名称" label-position="top" prop="nickname">
          <Input v-model="tradesman.nickname"></Input>
        </FormItem>
        <FormItem label="店铺简介" prop="describe">
          <Input v-model="tradesman.describe" type="textarea" :rows="4" placeholder="店铺简介..."></Input>
        </FormItem>
        <FormItem label="店铺详细介绍" prop="introduce">
<!--          <editor-bar v-model="tradesman.introduce" :isClear="isClear" ref="editContent"></editor-bar>-->
          <UEditor v-model="tradesman.introduce"  ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="身份证正面照" prop="legal_photo_facade">
          <upload-thumb
            v-model="tradesman.legal_photo_facade"
            :ref="thumbRefList[0]"
            :defaultList="thumblist[0]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照" prop="legal_photo_back">
          <upload-thumb
            v-model="tradesman.legal_photo_back"
            :ref="thumbRefList[1]"
            :defaultList="thumblist[1]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="匠人头像" prop="thumb">
          <upload-thumb
            v-model="tradesman.thumb"
            :ref="thumbRefList[2]"
            :defaultList="thumblist[2]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="形象图片" prop="image">
          <upload-thumb
            v-model="tradesman.image"
            :ref="thumbRefList[3]"
            :defaultList="thumblist[3]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="助力图片" prop="works">
          <upload-thumb
            v-model="tradesman.works"
            :ref="thumbRefList[4]"
            :defaultList="thumblist[4]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="执照号码" label-position="top">
          <Input v-model="tradesman.company_code"></Input>
        </FormItem>
        <FormItem label="营业执照照片" prop="company_photo">
          <upload-thumb
            v-model="tradesman.company_photo"
            :ref="thumbRefList[5]"
            :defaultList="thumblist[5]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="姓名" label-position="top">
          <Input v-model="tradesman.legal_person"></Input>
        </FormItem>
        <FormItem label="电话" label-position="top">
          <Input v-model="tradesman.phone"></Input>
        </FormItem>
        <FormItem label="客服电话" label-position="top">
          <Input v-model="tradesman.servicephone"></Input>
        </FormItem>
        <FormItem label="地址" label-position="top">
          <Input v-model="tradesman.address"></Input>
        </FormItem>
        <FormItem label="专题店铺缩略图" prop="special_thumb">
          <upload-thumb
            v-model="tradesman.special_thumb"
            :ref="thumbRefList[6]"
            :defaultList="thumblist[6]"
            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"
          ></upload-thumb>
        </FormItem>
        <FormItem label="专题店铺简介" prop="special_describe">
          <Input
            v-model="tradesman.special_describe"
            type="textarea"
            :rows="4"
            placeholder="专题店铺简介..."
          ></Input>
        </FormItem>
        <FormItem label="是否开发票" label-position="top">
          <RadioGroup v-model="tradesman.is_invoice">
            <Radio :label="0" :true-value="0">否</Radio>
            <Radio :label="1" :true-value="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="状态" label-position="top">
          <Tag color="green" v-if="tradesman.del_flag == 0">正常</Tag>
          <Tag color="red" v-if="tradesman.del_flag == 1">禁用</Tag>
          <!-- <RadioGroup v-model="tradesman.del_flag"  >
                        <Radio :label="0" :true-value="0">正常</Radio>
                        <Radio :label="1" :true-value="1">禁用</Radio>
          </RadioGroup>-->
        </FormItem>
        <FormItem label="是否推荐" label-position="top">
          <RadioGroup v-model="tradesman.is_pos">
            <Radio :label="0" :true-value="0">否</Radio>
            <Radio :label="1" :true-value="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="审核状态" label-position="top">
          <Select v-model="tradesman.status" clearable filterable placeholder="审核状态">
            <Option :value="0" :key="0">待审核</Option>
            <Option :value="1" :key="1">通过审核</Option>
            <Option :value="2" :key="2">未通过审核</Option>
          </Select>
        </FormItem>
        <FormItem label="排序" label-position="top">
          <Input v-model="tradesman.sort"></Input>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus4 = false">取消</Button>
        <Button type="primary" @click="editgoods('tradesmanValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from '../common/ueditor';
import uploadthumbTwo from "../common/thumb";
export default {
  name: "park-tradesmanlist",
  data() {
    const validateUnderlineFx = (rule, value, callback) => {
      if (this.dataInfo.underline_fx === "") {
        callback(new Error("请输入云支付分销比例"));
      } else {
        callback();
      }
    };
    const validateOnFx = (rule, value, callback) => {
      if (this.dataInfo.on_fx === "") {
        callback(new Error("请输入商城分销比例"));
      } else {
        callback();
      }
    };
    return {
      id: null, // 页面agentid
      loading: true,
      isable: false,
      isClear: false,
      dataloading: true,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      tablelist1: [],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "商户",
          key: "uuid",
          width: 300
        },
        {
          title: "名称",
          key: "nickname",
          minWidth: 160
        }
      ],
      columns2List: [],
      pages1: {
        page: 1,
        size: 10
      },
      search_s: {},
      list: [
        {
          title: "商户ID",
          key: "agent_uuid",
          width: 300,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null ? params.row.tradesman.uuid : ""
            );
          }
        },
        {
          title: "店铺名称",
          key: "nickname",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null ? params.row.tradesman.nickname : ""
            );
          }
        },
        {
          title: "联系人信息",
          key: "legal_person",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null && params.row.tradesman.data != null
                ? params.row.tradesman.data.legal_person
                : ""
            );
          }
        },
        {
          title: "电话",
          key: "username",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null && params.row.tradesman.data != null
                ? params.row.tradesman.data.phone
                : ""
            );
          }
        },
        {
          title: "云支付分销比例",
          key: "underline_fx",
          width: 160
        },
        {
          title: "商城分销比例",
          key: "on_fx",
          width: 160
        },
        {
          title: "二维码",
          key: "registe_at",
          minWidth: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "纯二维码："
              ),

              h(
                "a",
                {
                  attrs: {
                    href:
                      "https://admin.shidaijiyi.com/" +
                      params.row.tradesman.qrcode.path,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                "https://admin.shidaijiyi.com/" +
                  params.row.tradesman.qrcode.path
              ),

              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "合成的纯二维码："
              ),
              h(
                "a",
                {
                  attrs: {
                    href:
                      "https://admin.shidaijiyi.com/" +
                      params.row.tradesman.qrcode.path_new,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                "https://admin.shidaijiyi.com/" +
                  params.row.tradesman.qrcode.path_new
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.park_uuid, params.row.trades_uuid);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.park_uuid, params.row.trades_uuid);
                    }
                  }
                },
                "分销比例"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.editdetail(params.row.tradesman.id);
                    }
                  }
                },
                "编辑"
              )
            ]);
          }
        }
      ],
      thumbRefList: ["zero", "one", "two", "three", "four", "five", "six"],
      thumblist: [[], [], [], [], [], [], []],
      thumblistTwo: [],
      tablelist: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      showModalStatus: false,
      dataInfo: {
        underline_fx: 100,
        on_fx: 100
      },
      dataInfoValidate: {
        underline_fx: [
          { required: true, validator: validateUnderlineFx, trigger: "blur" }
        ],
        on_fx: [{ required: true, validator: validateOnFx, trigger: "blur" }]
      },
      showModalStatus3: false,
      showModalStatus4: false,
      tradesmanValidate: {},
      tradesman: {}
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
    this.getCateList();
    this.getSkillList();
    this.getItemList();
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function(curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function() {
      this.$api.park
        .agenttradesmanlist({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    getCateList() {
      this.$api.tradesman
        .catelist({ page: 1, size: 1000, status: 1 })
        .then(res => {
          if (res.code == 200) {
            this.cateList = res.result.list;
          }
        });
    },
    getSkillList() {
      this.$api.tradesman
        .skilllist({ page: 1, size: 1000, status: 1 })
        .then(res => {
          if (res.code == 200) {
            this.skillList = res.result.list;
          }
        });
    },
    getItemList() {
      this.$api.intangibleItem.list({ page: 1, size: 200 }).then(res => {
        if (res.code == 200) {
          this.intangibleList = res.result.list;
        }
      });
    },
    // 详情
    editdetail(index) {
      this.thumblist = [[], [], [], [], [], [], []];
      this.$refs["tradesmanValidate"].resetFields();
      this.showModalStatus4 = !this.showModalStatus4;
      this.tradesman.id = index;
      this.$api.tradesman.detail({ id: index }).then(res => {
        this.tradesman = res.result;
        this.tradesman.skill = this.tradesman.data.skill;
        this.tradesman.helpless_skill = this.tradesman.data.helpless_skill;
        this.tradesman.auth_company = this.tradesman.data.auth_company;
        this.tradesman.describe = this.tradesman.data.describe;
        this.tradesman.introduce = this.tradesman.data.introduce;
        this.tradesman.company_code = this.tradesman.data.company_code;
        this.tradesman.legal_person = this.tradesman.data.legal_person;
        this.tradesman.phone = this.tradesman.data.phone;
        this.tradesman.servicephone = this.tradesman.data.service_phone;
        this.tradesman.address = this.tradesman.data.address;
        this.tradesman.special_describe = this.tradesman.data.special_describe;
        this.$refs['editContent'].message = this.tradesman.introduce;
        //图片处理
        this.pushThumbData([
          this.tradesman.data.legal_photo_facade,
          this.tradesman.data.legal_photo_back,
          this.tradesman.thumb,
          this.tradesman.data.image,
          this.tradesman.data.works,
          this.tradesman.data.company_photo,
          this.tradesman.data.special_thumb
        ]);
      });
    },
    pushThumbData(list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished"
          });
        }
      }
    },
    // 修改
    editgoods(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs[this.thumbRefList[0]].uploadList.length > 0) {
            this.tradesman.legal_photo_facade = this.$refs[
              this.thumbRefList[0]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[1]].uploadList.length > 0) {
            this.tradesman.legal_photo_back = this.$refs[
              this.thumbRefList[1]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[2]].uploadList.length > 0) {
            this.tradesman.thumb = this.$refs[
              this.thumbRefList[2]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[3]].uploadList.length > 0) {
            this.tradesman.image = this.$refs[
              this.thumbRefList[3]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[4]].uploadList.length > 0) {
            this.tradesman.works = this.$refs[
              this.thumbRefList[4]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[5]].uploadList.length > 0) {
            this.tradesman.company_photo = this.$refs[
              this.thumbRefList[5]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[6]].uploadList.length > 0) {
            this.tradesman.special_thumb = this.$refs[
              this.thumbRefList[6]
            ].uploadList[0].url;
          }
          this.tradesman.introduce = this.$refs['editContent'].message;
          this.$api.tradesman.edit(this.tradesman).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus4 = !this.showModalStatus4;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(park_uuid, trades_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.park
            .tradremove({ trades_uuid: trades_uuid, park_uuid: park_uuid })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.park.agenttradesmanlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    createAgentTradesMan() {
      this.search_s.key = "";
      this.showModalStatus = true;
      this.$api.park.bintradlist({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 筛选
    renderTable1: function(name) {
      if (name != 1) {
        this.pages1.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size,
        id: this.id
      };
      this.$api.park.bintradlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow(selection, index) {
      this.selected = this.$refs.selection.getSelection();
      console.log(this.selected);
    },
    //选中提交
    ok() {
      this.tablelist1 = this.selected;
      this.$api.park
        .tradcreate({ park_uuid: this.id, tradUuidArrs: this.selected })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.$Message.success(res.msg);
            this.showModalStatus = false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    changePage1() {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    detail(park_uuid, trade_uuid) {
      this.dataInfo = {
        underline_fx: 100,
        on_fx: 100
      };
      this.$refs["dataInfoValidate"].resetFields();
      this.showModalStatus3 = !this.showModalStatus3;
      this.$api.park
        .traddetail({
          park_uuid: park_uuid,
          trades_uuid: trade_uuid
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.dataInfo = res.result;
            this.$Message.success(res.msg);
          }
        });
    },
    editTrade(name) {
      console.log(1);
      this.$refs[name].validate(valid => {
        console.log(2);
        if (valid) {
          console.log(3);
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$api.park.tradedit(this.dataInfo).then(res => {
            if (res.code == 200) {
              this.renderTable(1);
              this.showModalStatus3 = !this.showModalStatus3;
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
